module.exports = __webpack_public_path__ + "static/testimonials-map-1-1-ce38981276fe0ae8f5bd8a2c4abe39b7.png";